import { css } from 'styled-components';

export const pickerFocusStyle = css`
    ${({ theme }) => css`
        &.ant-picker-focused {
            border-color: ${theme.colors.primary.primary8};
        }
    `}
`;
